import { render, staticRenderFns } from "./ConfigSelectEgdsStrumentoList.vue?vue&type=template&id=47e1ea70"
import script from "./ConfigSelectEgdsStrumentoList.vue?vue&type=script&lang=js"
export * from "./ConfigSelectEgdsStrumentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports